import {
  FETCH_GUIDES_ASYNC,
  FETCH_GUIDES_ASYNC_END,
  FETCH_GUIDES_END_COMPLETE,
} from 'store/types';

import Guides from 'services/guides';
import { showToast } from './toast';

export const fetchGuides = (params) => async (dispatch, getState) => {
  dispatch({
    type: FETCH_GUIDES_ASYNC,
  });
  try {
    const {
      data: { list, ...rest },
    } = await Guides.getGuides(params);

    dispatch({
      type: FETCH_GUIDES_END_COMPLETE,
      payload: { list, pagination: rest },
    });
  } catch (error) {
    dispatch({
      type: FETCH_GUIDES_ASYNC_END,
    });
    dispatch(
      showToast(
        'error',
        error?.response?.data?.message || 'Something went wrong',
      ),
    );
  }
};
